import React from "react";
import { Box, Avatar, Menu, MenuItem } from "@material-ui/core";
import useAuth from "src/hooks/useAuth";
import { APIUrl } from "src/config";

const UserInfo = () => {
  const { logout, user } = useAuth();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout();
    handleClose();
  };

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        onClick={handleClick}
        style={{ cursor: "pointer" }}
      >
        <Box mr={1} align="right">
          <Box>{user && user.fullName}</Box>
        </Box>
        {user && user.avatar ? (
          <Avatar src={APIUrl + user.avatar} />
        ) : (
          <Avatar>{user && user.fullName && user.fullName.charAt(0)}</Avatar>
        )}
      </Box>
      <Menu
        id="user-profile-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem onClick={handleLogout}>Đăng xuất</MenuItem>
      </Menu>
    </>
  );
};

export default UserInfo;
